import 'typeface-roboto';
import '@covalent/core/common/platform.scss';
import './styles.scss';
import './polyfills';

import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { RootModule } from './root/root.module';

(async () => {
  try {
    window.config = await (await fetch('config.json')).json();
    if (config.isProd) {
      enableProdMode();
    }
    platformBrowserDynamic().bootstrapModule(RootModule);
  } catch (error) {
    // tslint:disable-next-line
    console.error(error);
  }
})();
